<template>
  <div class="addCommondity">
    <div class="goodsManageDetailPage">
      <div class="banner">
        <img src="../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <!-- <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div> -->
        <div class="breadcrumb_item">促销优惠&市场活动</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">市场活动管理</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1><span class="mark">*</span>活动名称：</h1>
          <div class="input_box">
            <van-field v-model="formData.actname" placeholder="输入活动名称" />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>活动封面（缩略图）</h1>
          <p class="red">JPG或者PNG格式，尺寸比例为500*750像素</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @delete="formData.actcover = ''"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>活动城市：</h1>
          <div class="select_box flex-between" @click="handleShowPopup(1)">
            <van-field
              v-model="formData.city"
              placeholder="请选择活动城市"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>活动地标：</h1>
          <div class="input_box">
            <van-field
              v-model="formData.position"
              placeholder="请输入活动地标"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>活动关联门店ID</h1>
          <div class="select_box flex-between" @click="handleShowPopup(2)">
            <van-field
              v-model="shopcodestr"
              placeholder="请选择活动关联门店ID"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>

        <div class="block">
          <div>
            <h1><span class="mark">*</span>开始预约日期：</h1>
            <div class="select_box flex-between" @click="handleShowPopup(3, 1)">
              <van-field
                v-model="formData.joinsdate"
                placeholder="开始预约日期"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div style="margin-top: 15px">
            <h1><span class="mark">*</span>结束预约日期：</h1>
            <div class="select_box flex-between" @click="handleShowPopup(4, 2)">
              <van-field
                v-model="formData.joinedate"
                placeholder="选择结束预约日期"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>
        <div class="block">
          <div>
            <h1><span class="mark">*</span>活动开始日期&时间：</h1>
            <div class="select_box flex-between" @click="handleShowPopup(5, 3)">
              <van-field
                v-model="formData.sdate"
                placeholder="选择活动结束日期&时间"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div style="margin-top: 15px">
            <h1><span class="mark">*</span>活动结束日期&时间：</h1>
            <div class="select_box flex-between" @click="handleShowPopup(6, 4)">
              <van-field
                v-model="formData.edate"
                placeholder="选择活动结束日期&时间"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>活动花费类型：</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.costtype" direction="horizontal">
              <van-radio name="免费">免费</van-radio>
              <van-radio name="普通用户积分报名">普通用户积分报名</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>是否仅限会员参加：</h1>
          <div class="radio_box">
            <van-radio-group
              v-model="formData.isactpermis"
              direction="horizontal"
            >
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
      <!-- <div class="return-fixd">
        
      </div> -->
    </div>

    <van-popup v-model="isShow" position="bottom" :style="{ height: '50%' }">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择活动"
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          value-key="areaname"
          @cancel="isShow = false"
        />
      </template>
      <template v-else-if="popupType == 2">
        <van-picker
          title="请选择关联门店"
          show-toolbar
          :columns="shopList"
          @confirm="onConfirm"
          value-key="shopname"
          @cancel="isShow = false"
        />
      </template>
      <template v-else>
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择年月日"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import {
  uploadPosterImage,
  getShopList,
  getProvince,
  encryptstringview,
} from "../../api/api";
import { getActivityDetail, editActivity, addActivity } from "../../api/shop";
export default {
  name: "addCommondity",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      isShow: false,
      popupType: 1,
      popupDate: 1,

      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      formData: {
        id: "",
        appid: "",
        actname: "",
        actcover: "",
        city: "",
        position: "",
        shopcode: "",
        joinsdate: "", // 开始预约日期
        joinedate: "", // 结束预约日期
        sdate: "", // 活动开始日期&时间
        edate: "", // 活动结束日期&时间
        costtype: "", // 活动花费类型 =现金报名 普通用户积分报名
        isactpermis: "", // 是否消耗权益码 =是 否

        openid: "", // 创建人openid
        truename: "", // 创建人姓名
        mobile: "", // 创建人手机号
        qyguid: "", // 创建人所属企业guid
        linkappid: "", // 企业关联业务端场景APPID
      },
      qyguid: "",
      fileList: [],
      provinceList: [],
      shopList: [],
      shopcodestr: "",
      currentDate: new Date(),
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.openid = USERINFO.openid;
    this.formData.truename = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;
    this.formData.mobile = USERINFO.mobile;
    if (USERINFO.qy) {
      this.formData.qyguid = USERINFO.qy.qyguid;
      this.formData.linkappid = USERINFO.qy.postappid;
      this.formData.appid = USERINFO.qy.postappid;
    } else {
      this.formData.qyguid = 0;
    }
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") {
        this.getProvince();
        this.getShopList();
      } else {
        this.encryptstringview(routerList[name].encryptstring, OPENID);
      }
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getActivityDetail(id);
      } else {
        this.$router.back();
      }
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },

    handleShowPopup(e, val) {
      this.isShow = true;
      this.popupType = e;
      this.popupDate = val;
    },

    // 确认弹窗
    onConfirm(e) {
      let { popupType, popupDate } = this;
      if (popupType == 1) {
        this.formData.city = e.areaname;
      } else if (popupType == 2) {
        this.formData.shopcode = e.shopid;
        this.shopcodestr = e.shopname;
      } else {
        let data = new Date(e);  
        let year = data.getFullYear();
        let month = data.getMonth() + 1;
        let months = month < 10 ? '0' + month : month;
        let day = data.getDate() < 10 ? '0' + data.getDate() : data.getDate();
        let hh = data.getHours() < 10 ? '0' + data.getHours() : data.getHours();
        let mm = data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes()
        let str = year + '-' + months + '-' + day + ' ' + hh + ':' + mm + ':' + '00'
        if (popupDate == 1) {
          this.formData.joinsdate = str
        }else if (popupDate == 2) {
          this.formData.joinedate = str
        }else if (popupDate == 3) {
          this.formData.sdate = str
        }else if (popupDate == 4) {
          this.formData.edate = str
        }
      }

      this.isShow = false;
    },

    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.formData.actcover = res.code;
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    // 获取门店列表
    getShopList() {
      let params = {
        Page: 1,
        PageSize: 100,
        qyguid: this.formData.qyguid,
      };
      getShopList(params).then((res) => {
        this.shopList = res;
      });
    },

    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.provinceList = res;
      });
    },

    // 获取活动详情
    getActivityDetail(id) {
      getActivityDetail({ id }).then((res) => {
        this.formData.actname = res.actname;
        this.formData.actcover = res.actcover.split("upload")[1];
        this.fileList.push({ url: res.actcover });
        this.formData.city = res.city;
        this.formData.position = res.position;
        this.formData.shopcode = res.shopcode;
        this.shopcodestr = res.shopcodestr;
        this.formData.joinsdate = res.joinsdate;
        this.formData.joinedate = res.joinedate;
        this.formData.sdate = res.sdate;
        this.formData.edate = res.edate;
        this.formData.costtype = res.costtype;
        this.formData.isactpermis = res.isactpermis;
        this.getProvince();
        this.getShopList();
      });
    },

    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;

      if (formData.actname == "") {
        this.$toast("请输入活动名称");
        return;
      }
      if (formData.actcover == "") {
        this.$toast("请上传活动封面（缩略图）");
        return;
      }
      if (formData.city == "") {
        this.$toast("请输入活动城市");
        return;
      }
      if (formData.position == "") {
        this.$toast("请输入活动地标");
        return;
      }
      if (formData.shopcode == "") {
        this.$toast("请选择活动关联门店ID");
        return;
      }
      if (formData.joinsdate == "") {
        this.$toast("请选择开始预约日期");
        return;
      }
      if (formData.joinedate == "") {
        this.$toast("请选择结束预约日期");
        return;
      }
      if (formData.sdate == "") {
        this.$toast("请选择活动开始日期&时间");
        return;
      }
      if (formData.edate == "") {
        this.$toast("请选择活动结束日期&时间");
        return;
      }
      if (formData.costtype == "") {
        this.$toast("请选择活动花费类型");
        return;
      }
      if (formData.isactpermis == "") {
        this.$toast("请选择是否消耗权益码");
        return;
      }

      if (formData.id == "") {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addActivity(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      } else {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editActivity(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageDetailPage {
  padding-bottom: 380px;
  .main_content {
    font-size: 30px;
    color: #444444;
    h1 {
      text-align: center;
      font-weight: 400;
      margin-bottom: 35px;
    }
    input {
      text-align: center;
    }
    .block {
      margin-bottom: 100px;
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
    }
    .input_box {
      margin-bottom: 30px;
    }
    p {
      line-height: 30px;
      font-size: 22px;
      color: #ff0012;
      text-align: center;
    }
  }
}
</style>